var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryWasherDryer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 171,
    viewBox: "0 0 82 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 82,
    height: 86,
    y: 85,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 85,
    x: 0.5,
    y: 85.5,
    stroke: "#F4F4F4",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M20.286 111c5.044-6.108 12.674-10 21.214-10 15.188 0 27.5 12.312 27.5 27.5S56.688 156 41.5 156c-8.997 0-16.985-4.32-22.002-11H13.5a2.5 2.5 0 110-5h3.013A27.398 27.398 0 0114 128.5c0-4.501 1.081-8.75 2.999-12.5H13.5a2.5 2.5 0 110-5h6.786z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M20.671 111.318l-.15.182H13.5a2 2 0 000 4h4.316l-.372.728A26.881 26.881 0 0014.5 128.5c0 3.951.849 7.781 2.467 11.29l.327.71H13.5a2 2 0 000 4h6.248l.15.2c5.07 6.75 12.999 10.8 21.602 10.8 14.912 0 27-12.088 27-27s-12.088-27-27-27a26.939 26.939 0 00-20.829 9.818z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 41.5,
    cy: 128.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 128.5,
    r: 22,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 82,
    height: 86,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 85,
    x: 0.5,
    y: 0.5,
    stroke: "#F4F4F4",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M62.714 61C57.67 67.108 50.04 71 41.5 71 26.312 71 14 58.688 14 43.5S26.312 16 41.5 16c8.997 0 16.985 4.32 22.002 11H69.5a2.5 2.5 0 110 5h-3.013A27.398 27.398 0 0169 43.5c0 4.501-1.081 8.75-2.999 12.5H69.5a2.5 2.5 0 110 5h-6.786z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M62.329 60.682l.15-.182H69.5a2 2 0 100-4h-4.316l.372-.728A26.881 26.881 0 0068.5 43.5a26.89 26.89 0 00-2.467-11.29l-.327-.71H69.5a2 2 0 100-4h-6.248l-.15-.2c-5.07-6.75-12.999-10.8-21.602-10.8-14.912 0-27 12.088-27 27s12.088 27 27 27a26.94 26.94 0 0020.829-9.818z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 41.5,
    cy: 43.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 43.5,
    r: 22,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 17,
    height: 9,
    x: 59,
    y: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 59.5,
    y: 6.5,
    stroke: "#F4F4F4",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D7D7D7",
    width: 23,
    height: 9,
    x: 54,
    y: 91,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 8,
    x: 54.5,
    y: 91.5,
    stroke: "#F4F4F4",
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 64.5,
    cy: 10.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 10.5,
    r: 2,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 64.5,
    cy: 95.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 95.5,
    r: 2,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 58.5,
    cy: 95.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 95.5,
    r: 1,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 70.5,
    cy: 10.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 10.5,
    r: 2,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 70.5,
    cy: 95.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 95.5,
    r: 2,
    stroke: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M7 8h5v5H7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M7.5 8.5h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M7 92h5v5H7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M7.5 92.5h4v4h-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryWasherDryer);
export default __webpack_public_path__ + "static/media/RoomSceneryWasherDryer.c0501e1f0074553a1ee1003a7bf8ab92.svg";
export { ForwardRef as ReactComponent };